import React, { useContext, useEffect, useRef, useState } from "react";
import {
	Stage,
	Layer,
	Image as KImage,
	Circle,
	Line,
	Group,
	Rect,
} from "react-konva";
import useImage from "use-image";
import { StopOutlined, ClearOutlined } from "@ant-design/icons";
import { popupcontext } from "../../../../context/Popupscontext";
import { useGetFloorplansQuery } from "../../../../Redux/service/ProjectSetup/ProjectSetup";
import { useDeletePOIMutation } from "../../../../Redux/service/POIS/POIs";
import { toast } from "react-toastify";
import trans, { isRTL } from "../../../../utils";

const MAX_SCALE = 5;

export default function SetupKonva({
	imageUrl,
	submitAttempt,
	setImageUrl,
	uniqueId,
	setUniqueId,
	selected,
	setSelected,
	select,
	setSelect,
	typeId,
	page,
	setTypeId,
	fetching,
	setClear,
	mode,
	setMode,
	back,
}) {
	const containerRef = useRef(null);
	const fitScaleRef = useRef(1);
	const minScaleRef = useRef(1);

	const [scale, setScale] = useState(1);
	const [position, setPosition] = useState({ x: 0, y: 0 });
	const [stageSize, setStageSize] = useState({ width: 0, height: 0 });
	const [polygons, setPolygons] = useState([]);
	const [points, setPoints] = useState([]);
	const [currentShape, setCurrentShape] = useState([]);
	const [name, setName] = useState(null);
	const [pointImg] = useImage(
		"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIGZpbGw9IiMyRTkyNDUiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIHN0cm9rZT0iI0JFRERDNSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yNyAxNEgyMUMxNy42OTA3IDE0IDE3IDE0LjY5MDcgMTcgMThWMzRIMzFWMThDMzEgMTQuNjkwNyAzMC4zMDkzIDE0IDI3IDE0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDM0SDMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNyAzNFYzMUMyNyAyOS4zNDUzIDI2LjY1NDcgMjkgMjUgMjlIMjNDMjEuMzQ1MyAyOSAyMSAyOS4zNDUzIDIxIDMxVjM0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjUuNSAxOEgyMi41TTI1LjUgMjEuNUgyMi41TTI1LjUgMjVIMjIuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K",
	);
	const [selectedPointImg] = useImage(
		"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIGZpbGw9IiMxODkwRkYiLz4KPHJlY3QgeD0iMSIgeT0iMSIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjQ2IiByeD0iMjMiIHN0cm9rZT0iI0U2RjdGRiIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0yNyAxNEgyMUMxNy42OTA3IDE0IDE3IDE0LjY5MDcgMTcgMThWMzRIMzFWMThDMzEgMTQuNjkwNyAzMC4zMDkzIDE0IDI3IDE0WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDM0SDMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNyAzNFYzMUMyNyAyOS4zNDUzIDI2LjY1NDcgMjkgMjUgMjlIMjNDMjEuMzQ1MyAyOSAyMSAyOS4zNDUzIDIxIDMxVjM0IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjUuNSAxOEgyMi41TTI1LjUgMjEuNUgyMi41TTI1LjUgMjVIMjIuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K",
	);
	const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

	const markerScreenSize = clamp(32 * Math.sqrt(scale), 18, 48);
	const markerInternal = markerScreenSize / scale;

	let { setKonvamode, konvaMode, setKonvaCoord, setReloadData, reloadData } =
		useContext(popupcontext);
	const {
		data: floorplans,
		refetch,
		error,
		isError,
	} = useGetFloorplansQuery({ id: typeId }, { skip: !typeId });
	useEffect(() => {
		if (!isError || !error) return;

		// RTK Query error shape
		const status = error?.status;

		if (status === 502) {
			toast.error(trans("Failed to generate layout. Please reload the page."), {
				autoClose: 2000,
				rtl: localStorage.getItem("lang") === "ar",
			});
		}
	}, [isError, error]);

	// page change logic
	useEffect(() => {
		if (!typeId) return;
		refetch(); // get new floorplan
		setMode("none"); // reset drawing mode
		setKonvamode(true);
	}, [page, typeId]);

	// data arrival logic
	useEffect(() => {
		if (floorplans?.data?.floorPlan?.imageUrl) {
			setImageUrl(floorplans.data.floorPlan.imageUrl);
		}
	}, [floorplans, back]);

	const [img] = useImage(imageUrl);

	let [deletePOI] = useDeletePOIMutation();
	console.log("Floor Plans", floorplans);
	useEffect(() => {
		if (mode === "point") {
			setKonvaCoord(points[points?.length - 1]);
		} else if (mode === "polygon") {
			setKonvaCoord(polygons[polygons?.length - 1]);
		}
	}, [mode, points, polygons]);
	useEffect(() => {
		const rooms = floorplans?.data?.rooms;
		if (!Array.isArray(rooms)) return;

		const points = rooms.filter((r) => r?.drawingType === "point");

		const polygons = rooms.filter(
			(r) =>
				r?.drawingType === "polygon" &&
				Array.isArray(r?.drawingCoordinates) &&
				r.drawingCoordinates.length > 0,
		);

		setPoints(points);
		setPolygons(polygons);
	}, [floorplans]);
	useEffect(() => {
		if (!typeId) return;

		if (reloadData) {
			refetch();
			setMode("none");
			setReloadData(false);
		}
	}, [reloadData, typeId]);

	const lastClick = useRef({ time: 0, x: 0, y: 0 });
	const DOUBLE_CLICK_MS = 300;
	const DOUBLE_CLICK_DIST = 8;

	const distance = (a, b) => Math.sqrt((a.x - b.x) ** 2 + (a.y - b.y) ** 2);

	const flatPoints = (poly) => poly.flatMap((p) => [p.x, p.y]);

	// 🔒 Clamp pan so image never hides
	const clampPosition = (pos, scaleValue = scale) => {
		if (!img) return pos;

		const imgW = img.width * scaleValue;
		const imgH = img.height * scaleValue;

		const minX = Math.min(0, stageSize.width - imgW);
		const minY = Math.min(0, stageSize.height - imgH);

		return {
			x: Math.max(minX, Math.min(0, pos.x)),
			y: Math.max(minY, Math.min(0, pos.y)),
		};
	};

	// ✅ Fit image
	useEffect(() => {
		if (!imageUrl || !containerRef.current) return;
		const toastId = toast(trans("Layout is loading..."), {
			type: "info",
			isLoading: true,
			autoClose: false,
			closeOnClick: false,
			rtl: isRTL,
		});

		const image = new window.Image();
		image.src = imageUrl;

		image.onload = () => {
			const cw = containerRef.current.offsetWidth;
			const ch = containerRef.current.offsetHeight;

			const fitScale = Math.min(
				cw / image.naturalWidth,
				ch / image.naturalHeight,
			);

			const pos = {
				x: (cw - image.naturalWidth * fitScale) / 2,
				y: (ch - image.naturalHeight * fitScale) / 2,
			};

			fitScaleRef.current = fitScale;
			minScaleRef.current = fitScale;

			setScale(fitScale);
			setPosition(pos);
			setStageSize({ width: cw, height: ch });
			// ✅ update toast to success
			toast.update(toastId, {
				render: trans("Layout ready"),
				type: "success",
				isLoading: false,
				autoClose: 1000,
				rtl: isRTL,
			});
		};

		image.onerror = () => {
			toast.update(toastId, {
				render: trans("Failed to load layout"),
				type: "error",
				isLoading: false,
				autoClose: 2000,
				rtl: isRTL,
			});
		};

		// cleanup in case component unmounts
		return () => {
			toast.dismiss(toastId);
		};
	}, [imageUrl]);

	const getImagePointer = (stage) => {
		const p = stage.getPointerPosition();
		return {
			x: (p.x - position.x) / scale,
			y: (p.y - position.y) / scale,
		};
	};

	// ✅ Click
	const handleClick = (e) => {
		if (mode === "none") return;

		const stage = e.target.getStage();
		const point = getImagePointer(stage);

		const now = Date.now();
		const last = lastClick.current;
		const timeDiff = now - last.time;
		const dist = distance(point, last);

		if (mode === "polygon" && konvaMode) {
			if (
				currentShape.length >= 3 &&
				timeDiff < DOUBLE_CLICK_MS &&
				dist < DOUBLE_CLICK_DIST
			) {
				setPolygons((p) => [
					...p,
					{
						drawingType: "polygon",
						drawingCoordinates: currentShape,
						id: p.id,
					},
				]);

				setCurrentShape([]);
				lastClick.current = { time: 0, x: 0, y: 0 };
				// setMode("none");
				setKonvamode(false);
				return;
			}
			setCurrentShape((s) => [...s, point]);
		}

		if (mode === "point" && konvaMode) {
			setPoints((p) => [
				...p,
				{
					drawingType: "point",
					drawingCoordinates: [{ x: point.x, y: point.y }],
					id: p.id,
				},
			]);
			// setMode("none");
			setKonvamode(false);
		}

		lastClick.current = { time: now, x: point.x, y: point.y };
	};

	// ✅ Zoom logic (shared)
	const applyZoom = (newScale, center) => {
		const mousePointTo = {
			x: (center.x - position.x) / scale,
			y: (center.y - position.y) / scale,
		};

		const pos = {
			x: center.x - mousePointTo.x * newScale,
			y: center.y - mousePointTo.y * newScale,
		};

		setScale(newScale);
		setPosition(clampPosition(pos, newScale));
	};

	const handleWheel = (e) => {
		e.evt.preventDefault();
		const stage = e.target.getStage();
		const pointer = stage.getPointerPosition();

		let newScale = e.evt.deltaY > 0 ? scale / 1.05 : scale * 1.05;

		newScale = Math.max(minScaleRef.current, Math.min(MAX_SCALE, newScale));
		applyZoom(newScale, pointer);
	};

	// ➕➖ Zoom buttons
	const zoomIn = () =>
		applyZoom(Math.min(scale * 1.2, MAX_SCALE), {
			x: stageSize.width / 2,
			y: stageSize.height / 2,
		});

	const zoomOut = () =>
		applyZoom(Math.max(scale / 1.2, minScaleRef.current), {
			x: stageSize.width / 2,
			y: stageSize.height / 2,
		});
	// 🗑 Delete
	const clearSelected = () => {
		if (!selected) return;

		if (selected.type === "point") {
			setPoints((p) => p.filter((_, i) => i !== selected.index));
		}

		if (selected.type === "polygon") {
			setPolygons((p) => p.filter((_, i) => i !== selected.index));
		}

		setMode("none");
		setKonvamode(true);
		setSelect(false);
		setSelected({
			type: null,
			index: null,
			polyid: null,
		});
	};
	const deleteSelected = async (id, name) => {
		try {
			await deletePOI(id).unwrap();
			toast.success(trans(`${name} Deleted Successfully`), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
			refetch();
			setUniqueId(null);
			setName(null);
			setSelect(false);
			setSelected({
				type: null,
				index: null,
				polyid: null,
			});
			setMode("none");
			setKonvamode(true);
		} catch (error) {
			console.error("error", error);
			toast.error(`${trans(error?.data?.message)}`, {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	};
	console.log("POINTS", points, "POLYGONS", polygons);
	return (
		<div
			style={{
				backgroundColor: "white",
				borderRadius: "16px",
				height: "calc(100vh - 80px)",
				marginBlock: "8px",
				position: "relative",
			}}
		>
			{" "}
			<div
				style={{
					position: "absolute",
					zIndex: "1",
					left: "95%",
					top: "10%",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{mode !== "point" && konvaMode && (
					<div
						className="konva-tool"
						style={{ backgroundColor: mode === "polygon" && "#D9D9D9" }}
						onClick={() => setMode("polygon")}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Polygon.svg`}
							alt="polygon"
						/>
					</div>
				)}
				{mode !== "polygon" && konvaMode && (
					<div
						className="konva-tool"
						style={{
							backgroundColor: mode === "point" && "#D9D9D9",
							marginBlock: "6px",
						}}
						onClick={() => setMode("point")}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Point.svg`}
							alt="point"
						/>
					</div>
				)}
				{/* {select &&
					(selected?.polyid === null || selected?.polyid === undefined) && (
						<div
							className="konva-tool"
							onClick={clearSelected}
							style={{ marginBottom: "6px" }}
						>
							<ClearOutlined />
						</div>
					)} */}
				{select && selected?.polyid && (
					<div
						className="konva-tool"
						onClick={() => deleteSelected(uniqueId, name)}
						style={{ marginBottom: "6px" }}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/Trash.svg`}
							alt="trash"
						/>
					</div>
				)}
				{(mode === "point" || mode === "polygon" || selected?.polyid) &&
					fetching === false && (
						<div
							className="konva-tool"
							onClick={() => {
								setCurrentShape([]);
								setPoints((prev) => prev.filter((p) => p?.id != null));
								setPolygons((prev) => prev.filter((p) => p?.id != null));
								setMode("none");
								setUniqueId(null);
								setSelected({
									type: null,
									index: null,
									polyid: null,
								});
								setSelect(false);
								setClear(true);
								setKonvamode(true);
							}}
						>
							<StopOutlined />
						</div>
					)}
			</div>
			{/* ➕➖ ZOOM UI */}
			<div className="konva-zoom ">
				<div
					disabled={scale >= MAX_SCALE}
					onClick={zoomIn}
					className="konva-tool-zoom mb-2"
				>
					+
				</div>
				<div
					disabled={scale <= minScaleRef.current}
					onClick={zoomOut}
					className="konva-tool-zoom"
				>
					−
				</div>
			</div>
			<div
				ref={containerRef}
				style={{
					width: "100%",
					height: "100%",
					overflow: "auto",
					borderRadius: "16px",
					border: "1px solid #c4c6c9ff",
					backgroundColor: "#0000001c",
				}}
			>
				<Stage
					width={stageSize.width}
					height={stageSize.height}
					onMouseDown={handleClick}
				>
					<Layer>
						<Group
							x={position.x}
							y={position.y}
							scaleX={scale}
							scaleY={scale}
							draggable={scale > minScaleRef.current} // ✅ only draggable when zoomed
							onDragMove={(e) => {
								const newPos = {
									x: e.target.x(),
									y: e.target.y(),
								};
								setPosition(clampPosition(newPos));
							}}
							onDragStart={(e) => {
								// ❌ block drag when not zoomed
								if (scale <= minScaleRef.current) {
									e.target.stopDrag();
								}
							}}
						>
							{img && <KImage image={img} />}
							<Rect
								x={0}
								y={0}
								width={img?.width}
								height={img?.height}
								fill="#f1f2f5ff"
								opacity={0.4}
							/>
							{polygons.map((poly, idx) => (
								<Line
									key={poly.id ?? idx}
									points={flatPoints(poly.drawingCoordinates)}
									closed
									stroke={
										selected?.type === "polygon" && selected.index === idx
											? "#f97316"
											: "#22c55e"
									}
									strokeWidth={2}
									fill="rgba(34,197,94,0.2)"
									onClick={() => {
										console.log("Selected Polygon", poly);
										if (poly?.id) {
											setSelect(true);
											setSelected({
												type: "polygon",
												index: idx,
												polyid: poly?.id,
											});
										}
										if (poly?.id) {
											setUniqueId(poly?.id);
											setName(poly?.name);
											setCurrentShape([]);

											// 🧹 clean invalid points
											setPoints((prev) => prev.filter((p) => p?.id != null));
											// 🧹 clean invalid polygons (FIXED)
											setPolygons((prev) => prev.filter((p) => p?.id != null));
										}
									}}
								/>
							))}

							{currentShape.length > 0 && (
								<>
									{/* Connected lines */}
									<Line
										points={flatPoints(currentShape)}
										stroke="#22c55e"
										strokeWidth={2}
										lineCap="round"
										lineJoin="round"
									/>

									{/* Vertices */}
									{currentShape.map((p, i) => (
										<Circle key={i} x={p.x} y={p.y} radius={5} fill="#22c55e" />
									))}
								</>
							)}

							{currentShape.length > 0 && (
								<Line points={flatPoints(currentShape)} stroke="#22c55e" />
							)}
							{points.map((p, i) => (
								<KImage
									key={i}
									image={
										selected?.type === "point" && selected.index === i && select
											? selectedPointImg
											: pointImg
									}
									x={p?.drawingCoordinates[0]?.x}
									y={p?.drawingCoordinates[0]?.y}
									width={markerInternal}
									height={markerInternal}
									offsetX={markerInternal / 2}
									offsetY={markerInternal / 2}
									onClick={() => {
										console.log("Selected Point", p);
										if (p.id) {
											setSelect(true);
											setSelected({
												type: "point",
												index: i,
												polyid: p?.id,
											});
										}
										if (p?.id) {
											setUniqueId(p?.id);
											setName(p?.name);
											// 🧹 clean invalid points
											setPoints((prev) =>
												prev.filter(
													(p) => p?.id != null, // removes null & undefined
												),
											);
											setCurrentShape([]);
											// 🧹 clean invalid polygons
											setPolygons((prev) =>
												prev.filter(
													(p) => p?.id != null, // removes null & undefined
												),
											);
										}
									}}
									shadowColor="#030302ff"
									shadowBlur={
										selected?.type === "point" && selected.index === i && select
											? 10
											: 0
									}
								/>
							))}
						</Group>
					</Layer>
				</Stage>
			</div>
		</div>
	);
}
